import { z } from 'zod'
import { MailDnsRecord } from './MailDns'

export const MailSubdomainDnsStatus = z.enum(['configured', 'missing', 'partial'])
export type MailSubdomainDnsStatus = z.infer<typeof MailSubdomainDnsStatus>

export const MailSubdomain = z.object({
  id: z.number(),
  name: z.string(),
  full_name: z.string(),
  created_at: z.string(),
  dns_status: MailSubdomainDnsStatus.optional()
})

export type MailSubdomain = z.infer<typeof MailSubdomain>

export const MailSubdomainListResponse = z.object({
  subdomains: z.array(MailSubdomain)
})

export type MailSubdomainListResponse = z.infer<typeof MailSubdomainListResponse>

export const SubdomainProvisionResult = z.object({
  id: z.number(),
  name: z.string(),
  full_name: z.string(),
  dkim_record: z.string(),
  dkim_selector: z.string()
})

export type SubdomainProvisionResult = z.infer<typeof SubdomainProvisionResult>

export const SubdomainDnsResponse = z.object({
  records: z.array(MailDnsRecord),
  status: MailSubdomainDnsStatus,
  auto_configurable: z.boolean().optional()
})

export type SubdomainDnsResponse = z.infer<typeof SubdomainDnsResponse>

export const SubdomainCatchAllResponse = z.object({
  enabled: z.boolean(),
  target_mailbox_id: z.number().optional(),
  target_email: z.string().optional()
})

export type SubdomainCatchAllResponse = z.infer<typeof SubdomainCatchAllResponse>

export const SetSubdomainCatchAllRequest = z.object({
  target_mailbox_id: z.number()
})

export type SetSubdomainCatchAllRequest = z.infer<typeof SetSubdomainCatchAllRequest>
